import {
  GET_ALL_ADMISSIONS,
  GET_ADMISSION,
  GET_ADMISSION_BY_NUMBER,
  GET_ADMISSION_BY_NUMBER_AND_ID,
} from 'actions/admin/admissions';

const initialState = {
  admissionData: {
    content: [],
  },
  admission: {},
  admissionByNumber: {},
  admissionByNumberAndId: {},
};

export default function admissions(state = initialState, action = {}) {
  switch (action.type) {
    case GET_ALL_ADMISSIONS:
      return { ...state, admissionData: action.admissionData };
    case GET_ADMISSION:
      return { ...state, admission: action.admission };
    case GET_ADMISSION_BY_NUMBER:
      return {
        ...state,
        admissionByNumber: action.admissionByNumber,
      };
    case GET_ADMISSION_BY_NUMBER_AND_ID:
      return {
        ...state,
        admissionByNumberAndId: action.admissionByNumberAndId,
      };
    default:
      return state;
  }
}
